import { ofType, combineEpics, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';
import { enqueueSnackbar } from '../../notifier/actions';

import {
  FETCH_PRODUCT_TYPE_MEMBERS_STARTED,
  fetchProductTypeMembersFulfilled,
  UPDATE_PRODUCT_TYPE_MEMBER_ROLE_STARTED,
  updateProductTypeMemberRoleFulfilled,
} from './actions';

const fetchProductTypeMembersEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_PRODUCT_TYPE_MEMBERS_STARTED),
    mergeMap((action: { payload: string}) =>
      from(Safescarf.fetchSafescarfProductTypeMembers(action.payload)).pipe(
        mergeMap((response: { data: unknown }) => of(fetchProductTypeMembersFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

const updateProductTypeMemberRoleEpic: Epic = action$ =>
  action$.pipe(
    ofType(UPDATE_PRODUCT_TYPE_MEMBER_ROLE_STARTED),
    mergeMap((action: { payload: Record<string, unknown> }) =>
      from(Safescarf.updateProductTypeMemberRole(action.payload)).pipe(
        mergeMap((response: { data: unknown }) =>
          of(
            updateProductTypeMemberRoleFulfilled(response.data),
            enqueueSnackbar({
              message: 'safescarfProductTypeMemberUpdated',
              options: { variant: 'success' },
            })
          )
        ),
        catchError(handleError)
      )
    )
  );

export default combineEpics(fetchProductTypeMembersEpic, updateProductTypeMemberRoleEpic);
